<template>
  <div class="content">
    <title-bar :title="$lang.bonus_title7"> </title-bar>
    <!-- <div style="margin-left: 10px; margin-right: 10px; margin-top: 10px">
      <img
        src="../../../assets/img/bonus/bonus10.png"
        width="100%"
        style="border-radius: 13px"
      />
    </div> -->
    <!-- <div style="position: relative; margin: 10px 10px 0 10px">
      <img
        src="../../../assets/img/bonus/bonus10.png"
        width="100%"
        style="border-radius: 13px"
      />
      <div style="position: absolute; top: 20px; left: 20px">
        <p
          style="font-weight: 800; font-size: var(--vk-fs-15); margin-bottom: 10px"
          v-html="$lang.common_txt234"
        ></p>
        <p v-html="$lang.common_txt235"></p>
      </div>
    </div> -->
    <div class="content-c">
      <div v-if="readError" class="signin-read-error">
        {{ readError }}
      </div>
      <div class="content-c--c">
        <p class="content-c--c1">{{ $lang.VIP }} {{ vipLevel }}</p>
        <p class="content-c--c2 font-color">
          {{ $lang.bonus_txt34 }}
          <span class="info-color"
            >{{ getCurrency }} {{ info.awardAmount }}</span
          >
        </p>
        <van-button
          size="large"
          class="custom-button"
          :class="{ active: isClaimUiDisabled() }"
          :disabled="claiming || isClaimUiDisabled()"
          @click="getJl"
        >
          {{ claiming ? ($lang.common_loading || 'Loading...') : $lang.Recebido }}
        </van-button>
        <img
          class="content-c--c5"
          src="../../../assets/img/bonus/six-bg2.png"
        />
      </div>

      <div
        class="content-c2--c2t"
        style="font-weight: bold; font-size: var(--vk-fs-md); margin: 15px 0px"
      >
        {{ $lang.bonus_txt35 }}
      </div>
      <div class="content-c3">
        <div class="content-c3--t font-color">
          <p>{{ $lang.bonus_txt36 }}</p>
          <p>{{ $lang.bonus_txt37 }}</p>
        </div>
        <div
          class="content-c3--t2"
          v-for="(item, index) in InitDate"
          :key="index"
          :style="(index + 1) % 2 === 0 ? {} : { backgroundColor: '#454654' }"
        >
          <p class="f-w">VIP{{ item.vipLevel }}</p>
          <p class="f-w">
            {{ $formatNumberWithCommas(item.reward) }}
          </p>
        </div>
      </div>
      <van-loading v-if="loading" color="#ff5a1f" vertical> </van-loading>
      <div
        class="d-flex f-t-15 f-w m-t-15 m-b-10"
        style="justify-content: center"
      >
        <span class="share-bot-l"></span>
        <span>{{ $lang.common_txt35 }}</span>
        <span class="share-bot-r"></span>
      </div>
      <div v-html="$lang.bonus_txt38" class="font-color"></div>
    </div>
  </div>
</template>
<script>
import { GetVipAwardInit, Init, GetVipAward } from '@/api/common'
import {
  failMessage as rewardFailMessage,
  hasRewardIssueProof,
  hasUnavailableMarker,
  isClaimSuccess as rewardClaimSuccess,
  isNeedLogin,
  isOkResponse,
  responseContent
} from '../activity/rewardApi'
export default {
  name: 'cashBack',
  components: {},
  data() {
    return {
      InitDate: [],
      info: {},
      vipLevel: 0,
      loading: false,
      readError: '',
      readErrors: {},
      claiming: false
    }
  },
  mounted() {
    if (this.token) {
      this.GetVipAwardInit()
      this.Init()
    }
  },
  methods: {
    requireLogin() {
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    isRewardNeedLogin(res) {
      if (isNeedLogin(res)) return true
      const stack = [res]
      for (let i = 0; i < stack.length; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (body.need_login === true || body.needLogin === true || [body.status, body.state, body.code, body.errorCode, body.need_login, body.needLogin].some(value => String(value || '').trim().toLowerCase() === 'need_login')) return true
        ;['content', 'data', 'page', 'extra'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    isFalseFlag(value) {
      const token = String(value == null ? '' : value).trim().toLowerCase()
      return value === false || value === 0 || token === 'false' || token === '0'
    },
    hasRewardWritableBlocker(res) {
      const stack = [responseContent(res), res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const writableFlags = [
          body.rewardWritable,
          body.reward_writable,
          body.claimWritable,
          body.claim_writable
        ]
        if (writableFlags.some(value => this.isFalseFlag(value))) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    hasRewardUnavailableMarker(res) {
      if (hasUnavailableMarker(res) || this.hasRewardWritableBlocker(res)) return true
      const stack = [res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const values = [
          body.readOnly,
          body.readOnlyMode,
          body.read_only_mode,
          body.readOnlyReward,
          body.read_only_reward,
          body.readOnlyAction,
          body.read_only_action,
          body.read_only,
          body.mock_fallback,
          body.not_implemented,
          body.not_supported,
          body.need_login,
          body.needLogin,
          body.notSupported,
          body.unsupported,
          body.technicalMarker,
          body.technical_marker,
          body.backendFailure,
          body.backend_failure,
          body.technicalError,
          body.technical_error,
          body.technicalException,
          body.technical_exception,
          body.fallback,
          body.dataUnavailable,
          body.data_unavailable,
          body.readUnavailable,
          body.read_unavailable,
          body.writeBlocked,
          body.readBlocked,
          body.read_blocked,
          body.backendBlocked,
          body.backend_blocked,
          body.rewardBackendBlocked,
          body.reward_backend_blocked,
          body.falseProof,
          body.false_proof,
          body.failClosed,
          body.fail_closed,
          body.unimplemented,
          body.failed,
          body.readonly,
          body.notImplemented,
          body.mock,
          body.mockMode,
          body.mock_mode,
          body.mockFallback,
          body.write_blocked,
          body.stub,
          body.msg,
          body.message,
          body.reason,
          body.desc,
          body.description,
          body.errorMsg,
          body.errorMessage,
          body.detail,
          body.readOnlyMessage,
          body.unavailableReason,
          body.status,
          body.state,
          body.result,
          body.code,
          body.errorCode,
          body.paymentStatusUnconfirmed,
          body.payment_status_unconfirmed,
          body.paymentStatus,
          body.payment_status,
          body.rewardStatus,
          body.reward_status
        ]
        const proofValues = [
          body.writeProof,
          body.write_proof,
          body.rewardProof,
          body.reward_proof,
          body.orderProof,
          body.order_proof,
          body.affectedProof,
          body.affected_proof,
          body.serverProof,
          body.server_proof
        ]
        if (proofValues.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === false || value === 0 || token === 'false' || token === '0' || token === 'fail' || token === 'failed'
        })) return true
        const markers = ['未接入', 'mock', 'mockMode', 'mock_mode', 'fallback', 'dataUnavailable', 'data unavailable', 'data_unavailable', 'readUnavailable', 'read unavailable', 'read_unavailable', 'readBlocked', 'read blocked', 'read_blocked', 'stub', '只读', 'readOnlyMode', 'read_only_mode', 'readOnlyReward', 'read_only_reward', 'readOnlyAction', 'read_only_action', '阻止假成功', 'writeBlocked', 'paymentStatusUnconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'writeProof', 'write_proof', 'writeProof:false', 'write_proof:false', 'falseProof', 'false_proof', 'false proof', 'failClosed', 'fail_closed', 'fail closed', 'backendBlocked', 'rewardBackendBlocked', 'backend_blocked', 'reward_backend_blocked', 'technicalMarker', 'technical_marker', 'technical marker', 'backendFailure', 'backend_failure', 'backend failure', 'technicalException', 'technical_exception', 'technical exception', 'technicalError', 'technical_error', 'technical error', 'not_implemented', 'not_supported', 'not supported', 'need_login', 'need login', 'need-login', 'unsupported', 'unimplemented', 'failed']
        if (values.some((value) => {
          if (value === true || value === 1) return true
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && markers.some((marker) => token.includes(String(marker).toLowerCase()))
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    failMessage(res, fallback) {
      return rewardFailMessage(res, fallback || this.$lang.mc_claim_failed || 'This feature is temporarily unavailable. Please try again later.')
    },
    safeToast(message, icon = 'cross') {
      if (typeof this.$toast === 'function') {
        this.$toast({
          message,
          icon
        })
      }
    },
    showFailToast(res, fallback) {
      this.safeToast(this.failMessage(res, fallback), 'cross')
    },
    readFailureMessage(res, fallback) {
      return `${this.failMessage(res, fallback)}，已保留已加载数据。`
    },
    syncReadError() {
      const errors = this.readErrors || {}
      this.readError = ['award', 'vip']
        .map(key => errors[key])
        .filter(Boolean)
        .join(' ')
    },
    clearReadError(scope = 'award') {
      this.readErrors = {
        ...(this.readErrors || {}),
        [scope]: ''
      }
      this.syncReadError()
    },
    showReadError(res, fallback, scope = 'award') {
      const message = this.readFailureMessage(res, fallback)
      this.readErrors = {
        ...(this.readErrors || {}),
        [scope]: message
      }
      this.syncReadError()
      this.safeToast(message, 'cross')
    },
    isClaimUiDisabled() {
      const errors = this.readErrors || {}
      const hasAwardReadError = !!errors.award
      const hasVipOnlyReadError = !!errors.vip && !hasAwardReadError
      const hasLegacyReadError = !!this.readError && !hasVipOnlyReadError
      return hasAwardReadError || hasLegacyReadError || Number(this.info && this.info.receiveStatus) !== 1
    },
    isReadUnavailable(res) {
      const stack = [res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const values = [
          body.dataUnavailable,
          body.data_unavailable,
          body.readUnavailable,
          body.read_unavailable,
          body.readBlocked,
          body.read_blocked
        ]
        if (values.some((value) => {
          if (value === true || value === 1) return true
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return ['true', '1', 'dataunavailable', 'data_unavailable', 'data unavailable', 'readunavailable', 'read_unavailable', 'read unavailable', 'readblocked', 'read_blocked', 'read blocked'].includes(token)
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    safeRuleList(value) {
      if (Array.isArray(value)) return value
      if (!value) return []
      if (typeof value === 'string') {
        try {
          return this.safeRuleList(JSON.parse(value))
        } catch (e) {
          return []
        }
      }
      if (typeof value !== 'object') return []
      return this.firstRuleList(value)
    },
    firstRuleList(source, depth = 0) {
      if (!source || typeof source !== 'object' || depth > 5) return []
      const listKeys = ['ruleList', 'rules', 'list', 'records', 'dataList', 'items']
      for (const key of listKeys) {
        const value = source[key]
        if (Array.isArray(value)) return value
        if (typeof value === 'string') {
          const parsed = this.safeRuleList(value)
          if (parsed.length) return parsed
        }
      }
      const envelopeKeys = ['content', 'data', 'payload', 'extra', 'page', 'body']
      for (const key of envelopeKeys) {
        const value = source[key]
        if (!value || (typeof value !== 'object' && typeof value !== 'string')) continue
        const list = typeof value === 'string'
          ? this.safeRuleList(value)
          : this.firstRuleList(value, depth + 1)
        if (list.length) return list
      }
      return []
    },
    normalizeRuleList(list) {
      return this.safeRuleList(list)
        .filter((item) => item && typeof item === 'object' && (
          Object.prototype.hasOwnProperty.call(item, 'vipLevel') ||
          Object.prototype.hasOwnProperty.call(item, 'reward')
        ))
        .map((item) => ({
          ...item,
          vipLevel: Number(item && item.vipLevel) || 0,
          reward: Number(item && item.reward) || 0
        }))
    },
    isRewardWriteDisabled(content, source) {
      const c = content || {}
      return this.hasRewardUnavailableMarker(source || c) ||
        this.hasRewardUnavailableMarker(c) ||
        c.rewardWritable === false ||
        String(c.rewardWritable).trim().toLowerCase() === 'false' ||
        c.writeEnabled === false ||
        String(c.writeEnabled).trim().toLowerCase() === 'false'
    },
    claimableReceiveStatus(content, source) {
      const status = Number(content && content.receiveStatus) || 0
      return this.isRewardWriteDisabled(content, source) ? 0 : status
    },
    hasRewardWriteProof(res) {
      if (this.hasRewardUnavailableMarker(res)) return false
      const stack = [responseContent(res), res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const proofs = [
          body.writeProof,
          body.write_proof,
          body.affectedProof,
          body.affected_proof,
          body.affectedRowsProof,
          body.affected_rows_proof,
          body.count,
          body.serverProof,
          body.server_proof,
          body.serverRewardProof,
          body.server_reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (proofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === false || value === 0 || token === 'false' || token === '0' || token === 'fail' || token === 'failed'
        })) return false
        const positiveProofs = [
          body.rewardProof,
          body.reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (positiveProofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === true || value === 1 || token === 'true' || token === '1' || token === 'success' || token === 'ok'
        })) return true
        const recordProofs = [
          body.recordNo,
          body.record_no,
          body.recordId,
          body.record_id,
          body.rewardRecordNo,
          body.reward_record_no,
          body.rewardRecordId,
          body.reward_record_id,
          body.receiveRecordNo,
          body.receive_record_no,
          body.receiveRecordId,
          body.receive_record_id,
          body.claimRecordNo,
          body.claim_record_no,
          body.claimRecordId,
          body.claim_record_id
        ]
        const hasRecordProof = recordProofs.some((value) => {
          if (value && typeof value === 'object') return false
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && !['true', '1', 'success', 'ok', 'false', '0', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder', 'mock', 'mockmode', 'mock_mode', 'mockfallback', 'mock_fallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'readonly', 'readonlymode', 'read_only', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readonlyaction', 'read_only_action', 'writeblocked', 'write_blocked', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'falseproof', 'false_proof', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalmarker', 'technical_marker', 'backendfailure', 'backend_failure', 'technicalerror', 'technical_error', 'unimplemented', 'notimplemented', 'not_implemented', 'notsupported', 'not_supported'].includes(token)
        })
        const aliasProofs = [
          body.serverRewardProof,
          body.server_reward_proof
        ]
        if (hasRecordProof && aliasProofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === true || value === 1 || token === 'true' || token === '1' || token === 'success' || token === 'ok'
        })) return true
        const concreteProofs = [
          body.rewardProof,
          body.reward_proof,
          body.serverRewardProof,
          body.server_reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (concreteProofs.some((value) => {
          if (value && typeof value === 'object') return false
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && !['true', '1', 'success', 'ok', 'false', '0', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder', 'mock', 'mockmode', 'mock_mode', 'mockfallback', 'mock_fallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'readonly', 'readonlymode', 'read_only', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readonlyaction', 'read_only_action', 'writeblocked', 'write_blocked', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'falseproof', 'false_proof', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalmarker', 'technical_marker', 'backendfailure', 'backend_failure', 'technicalerror', 'technical_error', 'unimplemented', 'notimplemented', 'not_implemented', 'notsupported', 'not_supported'].includes(token)
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    hasExplicitRewardSuccess(res) {
      const c = responseContent(res)
      return [
        c.receiveSuccess,
        c.claimSuccess,
        c.signSuccess,
        c.paySuccess,
        c.success,
        c.received,
        c.claimed,
        c.signed
      ].some(value => value === true || value === 1 || ['1', 'true', 'success', 'ok'].includes(String(value == null ? '' : value).trim().toLowerCase()))
    },
    isReceiveSuccess(res) {
      return !this.hasRewardUnavailableMarker(res) && rewardClaimSuccess(res, (c) => {
        return ['claimed', 'received', 'completed'].includes(String(c.promoStatus || '').trim().toLowerCase())
      }) && this.hasExplicitRewardSuccess(res) && (hasRewardIssueProof(res) || this.hasRewardWriteProof(res)) && this.hasRewardWriteProof(res)
    },
    async getJl() {
      if (this.claiming) return
      if (this.isClaimUiDisabled()) {
        this.showFailToast(null, this.readError || this.$lang.mc_claim_failed || 'This feature is temporarily unavailable. Please try again later.')
        return
      }
      if (!this.token) {
        this.requireLogin()
        return
      }
      this.claiming = true
      try {
        const data = await GetVipAward()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (this.isReceiveSuccess(data)) {
          this.$toast({
            message: this.$lang.bonus_txt16,
            icon: 'success'
          })
          this.GetVipAwardInit()
        } else {
          this.showFailToast(data)
        }
      } catch (e) {
        this.showFailToast(e, this.$lang.network_error || '活动请求失败，请稍后重试。')
      } finally {
        this.claiming = false
      }
    },
    async Init() {
      try {
        const data = await Init()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (isOkResponse(data) && !this.isReadUnavailable(data)) {
          const content = responseContent(data)
          this.vipLevel = Number(content.vipLevel) || 0
          this.clearReadError('vip')
        } else {
          this.showReadError(data, null, 'vip')
        }
      } catch (e) {
        this.showReadError(e, this.$lang.network_error || '活动请求失败，请稍后重试。', 'vip')
      }
    },
    async GetVipAwardInit() {
      this.loading = true // 开始加载
      try {
        const data = await GetVipAwardInit()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (isOkResponse(data) && !this.isReadUnavailable(data)) {
          const content = responseContent(data)
          this.InitDate = this.normalizeRuleList(content)
          this.info = {
            ...content,
            awardAmount: Number(content.awardAmount) || 0,
            receiveStatus: this.claimableReceiveStatus(content, data)
          }
          this.clearReadError('award')
        } else {
          this.showReadError(data, null, 'award')
        }
      } catch (e) {
        this.showReadError(e, this.$lang.network_error || '活动请求失败，请稍后重试。', 'award')
      } finally {
        this.loading = false // 加载结束
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content-c {
  padding: 0% 3% 10% 3%;
}
.signin-read-error {
  margin: 10px 0;
  padding: 10px 12px;
  border: 1px solid rgba(255, 187, 0, 0.45);
  border-radius: 8px;
  background: rgba(255, 187, 0, 0.08);
  color: #ffcf66;
  line-height: 18px;
}
.content-c--c {
  margin-top: 10px;
  position: relative;
  border-radius: 15px;
  width: 100%;
  background: @cont-bg;
  border: 1px solid @info2-color;
  height: 155px;
}
.content-c--c1 {
  position: absolute;
  font-size: 45px;
  left: 5%;
  top: 10%;
  font-weight: bold;
  background: linear-gradient(to bottom, #feef92, #c6a94d);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.content-c--c2 {
  position: absolute;
  left: 5%;
  top: 45%;
}
.active {
  // box-shadow: 0 4px 1px #4a4a4a !important; /* 阴影效果 */
  background: #9b9b9b !important;
  border-bottom: 0px solid #494949 !important;
}
.custom-button {
  opacity: 1;
  position: absolute;
  margin-top: 15px;
  width: 130px;
  height: 38px;
  left: 5%;
  bottom: 10%;
  border-radius: 13px;
}
.content-c--c5 {
  position: absolute;
  right: 3%;
  width: 162px;
  top: -2%;
}
.content-c2 {
  font-size: var(--vk-fs-md);
  font-weight: bold;
  margin-top: 18px;
  background: #076237;
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 260px; /* 或者指定具体的宽度 */
  padding: 3px 10px;
}
.content-c3--t {
  margin-top: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px 12px 0 0;
  padding: 3.2% 21.5% 3.2% 18.5%;
  background: @cont-bg;
}
.content-c3--t2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 11% 12px 6%;
  background: @cont-bg;
}
.content-c3--t2 p {
  width: 40%;
  text-align: center;
}
.content-c3--t3 {
  // border-radius: 0 0 15px 15px;
  height: 0px;
  // background: @cont-bg;
}
.content-c4 {
  font-size: var(--vk-fs-md);
  font-weight: bold;
  margin-top: 18px;
  background: #076237;
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 260px; /* 或者指定具体的宽度 */
  padding: 3px 10px;
}
.content-c3 :last-child {
  border-radius: 0 0 12px 12px !important;
}

/* PC 端样式 */
@media (min-width: 769px) {
  .content-c3--t {
    padding: 3.2% 96px 3.2% 80px;
  }
}
</style>
